import i18n from 'src/i18n';
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };

  Table.tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 100,
    },
    {
      prop: 'description',
      label: i18n.t('common_words.description'),
      minWidth: 100,
    },
    {
      prop: 'capture_type',
      label: i18n.t('common_words.type_of_capture'),
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'qualification_type',
      label: i18n.t('common_words.type_of_qualification'),
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'username',
      label: i18n.t('common_words.user'),
      minWidth: 100,
      sortable: true,
    },
  ];

  const Search = { ...Tables.Search };

  return { Table, Search };
};

export default configTable;
